export enum SvgIconsNames {
  UserPlus = 'UserPlus',
  Contacts = 'Contacts'
}